module.exports = __webpack_public_path__ + "img/hero-4.e92e7ed7.jpg";